import  swal from 'sweetalert2';
import { Component, OnInit} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { faCheckDouble, faEnvelope, faSave, faCheck  } from '@fortawesome/free-solid-svg-icons';
import { RellamadaComponent } from 'app/modals/rellamada/rellamada.component';
import { PorcentajeConsultaComponent } from 'app/modals/porcentaje-consulta/porcentaje-consulta.component';
import { ServiciosService } from 'app/services/servicios.service';
import { Subject } from 'rxjs';
import { FormularioDespacho } from 'app/entities/formulario-despacho';
import { Service } from 'app/entities/servicios-backend';
import { Eps } from 'app/entities/eps';
import { Sintoma } from 'app/entities/sintomas';
import { TipoServicio } from 'app/entities/tipo_servicio';
import { FormaPago } from 'app/entities/formas-pago';
import { Novedad } from 'app/entities/novedades';
import { MotivoCancelacion } from 'app/entities/motivo-cancel';
import { DireccionServicioComponent } from 'app/modals/direccion-servicio/direccion-servicio.component';
import { MovilDespachoComponent } from 'app/modals/movil-despacho/movil-despacho.component';
import { TotalServiciosComponent } from 'app/modals/total-servicios/total-servicios.component';
import { BitacoraUsuarioComponent } from 'app/modals/bitacora-usuario/bitacora-usuario.component';
import { PqrsComponent } from 'app/modals/pqrs/pqrs.component';
import { CscTrasladoComponent } from 'app/modals/csc-traslado/csc-traslado.component';
import { OrdenCscComponent } from 'app/modals/orden-csc/orden-csc.component';
import { fadeOutOnLeaveAnimation } from 'angular-animations';
import { FormaPagoComponent } from 'app/modals/forma-pago/forma-pago.component';
import { EvaluacionComponent } from 'app/modals/evaluacion/evaluacion.component';
import { CelularDespachoComponent } from 'app/modals/celular-despacho/celular-despacho.component';
import { DireccionComponent } from '../../../../../modals/direccion/direccion.component';
import { PrioridadPorSintomaComponent } from 'app/modals/prioridad-por-sintoma/prioridad-por-sintoma.component';
import { MatSnackBar } from '@angular/material';
import { NotasDespachoComponent } from 'app/modals/notas-despacho/notas-despacho.component';
import { DireccionService } from '../../../../../services/direccion.service';
import { BeneficiariosService } from 'app/services/beneficiarios.service';
import { TitularesService } from 'app/services/titulares.service';
import { PrioridadesService } from 'app/services/prioridades.service';
import { InfoSmsComponent } from 'app/modals/info-sms/info-sms.component';
import { InfoConsecutivoComponent } from 'app/modals/info-consecutivo/info-consecutivo.component';

@Component({
  selector: 'app-fromulariodespacho',
  templateUrl: './fromulariodespacho.component.html',
  styleUrls: ['./fromulariodespacho.component.scss'],
  animations: [
    fadeOutOnLeaveAnimation({
      duration: 700
    })
  ]
})
export class FromulariodespachoComponent implements OnInit {

  constructor(
              private dialog: MatDialog,
              private serviciosService: ServiciosService,
              private snack: MatSnackBar,
              private _geo:DireccionService,
              private benService: BeneficiariosService,
              private titService: TitularesService,
              private prioridades: PrioridadesService
              ) {
    this.serviciosService.newService.subscribe((service:Service)=>{
        this.tableOpt.unshift(service);
        swal.fire({
          text:'Se agregó correctamente el servicio',
          title:'Se agregó el nuevo servicio',
          timer:1000,
          showConfirmButton:false,
          type:'success'
        })
    });
    this.tiempoMax = 90;
    this.conteo = 0;
    this.porcentajes = {
      reqhdp: 5,
      HConsCSC: 5,
      reqhll: 10,
      HCreaHC: 10,
      HMotAnte: 20,
      HExaFis: 10,
      Htratamiento: 10,
      HFirma: 15,
      HCodiValo: 8,
    };
    this.serviciosService.nuevaRellamada.subscribe(succ => {
      this.formModel.rellamadas = succ.cantidad;
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.tableOpt.length; i++){
        if (this.tableOpt[i].reqcsc === succ.csc ){
          this.tableOpt[i].rellamadas = succ.cantidad;
        }
      }
    });
    this.serviciosService.nuevoConsecutivo.subscribe((nuevodato: {frontProp: string, backProp: string, value: string, csc: string, formProps: Array<any>}) => {
      if (this.formModel.consecutivo === nuevodato.csc && nuevodato.formProps !== undefined){
        this.formModel[nuevodato.formProps[0]] = nuevodato.value || this.formModel[nuevodato.formProps[0]];
        this.formModel[nuevodato.formProps[1]] = nuevodato.value || this.formModel[nuevodato.formProps[1]] ;
      }
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.tableOpt.length; i++){
        if (this.tableOpt[i]["reqcsc"] === nuevodato.csc ){
          if (nuevodato.value === ""){
            this.tableOpt[i][nuevodato.frontProp] = nuevodato.value;
          }else{
            this.tableOpt[i][nuevodato.frontProp] = nuevodato.value || this.tableOpt[i][nuevodato.frontProp];
          }
        }
      }
    });
    this.serviciosService.servicioFinalizado.subscribe(data => {
      for (let index = 0; index < this.tableOpt.length; index++){
        if (this.tableOpt[index].reqcsc === data.csc){
          this.finalizarConsulta(index);
        }
      }
    });

    this.serviciosService.trasladado.subscribe((traslado: { csc: string; csctraslado: string; }) => {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < this.tableOpt.length; i++) {
        if (this.tableOpt[i]["reqcsc"] === traslado.csc) {
          this.tableOpt[i]['REGCSCTrasl'] = traslado.csctraslado;
        }
      }
    });
    this.formModel = new FormularioDespacho();

    this.tableOpt = [];

    this.faCheckDouble = faCheckDouble;
    this.faEnvelope = faEnvelope;
    this.faSave = faSave;
    this.faCheck = faCheck;
  }

  get PS(){
    if (!this.formModel.consecutivo){
      return 0;
    }
    let acumulador = 0;
    for (const prop in this.porcentajes){
      if (this.formModel[prop] !== null && this.formModel[prop] !== ""){
        acumulador += this.porcentajes[prop];
      }
    }
    return acumulador;
  }
  public tiempoMax: number;
  public apCod: Array<any>;
  public datosMovil;
  public tableOpt: Array<Service>;
  public tipoServicios: Array<TipoServicio>;
  public formasPago: Array<FormaPago>;

  public datosUsuario = JSON.parse(localStorage.getItem('usuario'));

  colorpb = 'primary';
  mode = 'determinate';
  value = 80;
  bufferValue = 75;

  /* estas variables se encargan de darle el valor del tiempo maximo de la columna TSC segun su triaje
      y tambien los porcentajes por los cuales se esta dividiendo  */
  public rojo;
  public amarillo;
  public verde;
  public verde2;
  public verde3;
  public verde4;
  public valuetsc1=25;
  public valuetsc2=50;
  public valuetsc3=75;
  public valuetsc4=100;

  rangosPrioridad;

  public spinner;

  public countsms;

  public faCheckDouble;
  public faEnvelope;
  public faSave;
  public faCheck;

  public conteo:number;
  public prioridad;
  public ponderado;
  public full;
  public formModel: FormularioDespacho;

  coinwallet: string[] = ['Antecedentes', 'N.Consulta', 'N.Operador'];
  selectedwallet = this.coinwallet[0];

  public listEps: Array<Eps>;
  public listSintomas: Array<Sintoma>;
  public novedades: Array<Novedad>;
  public motivosCancelacion: Array<MotivoCancelacion>;
  private porcentajes;
  beneficiarios: any;
  meses: any;

  async ngOnInit() {
    this.rangosPrioridad = await this.prioridades.prioridades()
    // Obtiene todos los codigos ap que hay en el sistema
    this.serviciosService.codigosAP().subscribe((aps: Array<any>) => {
      this.apCod = [];
      for (const ap of aps ){
        this.apCod.push(ap.tpccod);
      }
    });
    // Obtiene todas las eps que hay en db para llenar el select de eps
    this.serviciosService.getAllEps().subscribe(eps => {
      this.listEps = eps;
    });
    // Obtiene todos los sintomas para el campo que hay en evaluación
    this.serviciosService.getAllSintomas().subscribe(sintomas => {
      this.listSintomas = sintomas;
    });

    // Trae todos los formas de pago para el select fPago
    this.serviciosService.formasDePago().subscribe(formas => {
      this.formasPago = formas;
    });

    this.serviciosService.getAllTipoServicios().subscribe(tipos => this.tipoServicios = tipos);
    this.serviciosService.novedades().subscribe(novedades => this.novedades = novedades);
    this.serviciosService.cancelacion().subscribe(motivos => this.motivosCancelacion = motivos);

    this.getServicios();

    this.serviciosService.serviciostiemposconsulta().subscribe((data)=>{
      this.rojo = data[0].tiempo;
      this.amarillo = data[1].tiempo;
      this.verde = data[2].tiempo;
      this.verde2 = data[3].tiempo;
      this.verde3 = data[4].tiempo;
      this.verde4 = data[5].tiempo;
    })
  }

  progresoConsulta(){
    this.dialog.open(PorcentajeConsultaComponent);
  }

  rellamada(){
    if (this.formModel.consecutivo != null){
      const rellamadas: MatDialogRef<RellamadaComponent> = this.dialog.open(RellamadaComponent, {
        width:'50vw',
        data: {csc: this.formModel.consecutivo}
      });
      rellamadas.afterClosed().subscribe(size => {
        this.serviciosService.nuevasRellamadasEmit(this.formModel.consecutivo, size || this.formModel.rellamadas);
      });
    }
  }

  direccion() {
    if (!this.formModel.consecutivo) { return; }
    let newDir:MatDialogRef<DireccionComponent> = this.dialog.open(DireccionComponent, {
        width: '60%',
        height: '79%',
        data: { actual_direccion: this.formModel.direccion,key:(this.formModel.ap)?this.formModel.matricula:this.formModel.documento_paciente,tipoDir:'beneficiario' },
        disableClose:true
    });

    newDir.afterClosed().subscribe(direccion=>{
        console.log(direccion);
        if(direccion){
            this._geo.saveDir(direccion,(this.formModel.ap)?this.formModel.matricula:this.formModel.documento_paciente).subscribe(succ=>{
                swal.fire({
                    title:'Exito',
                    type:'success',
                    text:'Se guardó con exito la dirección',
                    showConfirmButton:false,
                    timer:1000
                })
            });
        }
    })
  }
/* trae toda la informacion de la tabla de servicios */
  async getServicios() {
    this.spinner = true;
    this.serviciosService.getPrioridad().subscribe(
      (data: Array<Service>) => {
        this.tableOpt = data;
        console.log(data);
        this.serviciosService.getPrioridadDespacho(this.tableOpt).subscribe(data=>{
          console.log(data);
          for (let i = 0; i < this.tableOpt.length; i++) {
            const tableRow = this.tableOpt[i];
            if (tableRow.reqcda === 'V'){
                if (tableRow.ApoyoVip === 1){
                    tableRow.prioridad = 'VIP';
                } else if (tableRow.Ape === 1) {
                    tableRow.prioridad = 'APE';
                }else if(tableRow.grutpc === 5){
                    tableRow.prioridad = 'AREA';
                }else if (tableRow.bencba === 15){
                    tableRow.prioridad = 'COR';
                }else{
                    tableRow.prioridad = data[i].prioridad;
                }
            }
          }
        });
        this.spinner = false;
      }
    );
  }

  reloadingetServicios(): void{
    this.getServicios();
  }

  getTSC(index: number = 0, maxTime: number): number{
    const date = new Date();
    let horaActual: Date = new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`);
    if (this.tableOpt[index].reqhll) {
      horaActual = new Date(`${this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "")} ${this.tableOpt[index].reqhll}`);
    }
    const horaServicio = new Date(`${this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "")} ${this.tableOpt[index].reqhor}`);
    const diferenciaDeTiempo = (horaActual.getTime() - horaServicio.getTime());
    const diferenciaDeTiempoEnMinutos = Math.floor(diferenciaDeTiempo / (60000));
    const porcentajeDeDiferenciaConRespectoAlMaximo = diferenciaDeTiempoEnMinutos * 100 / maxTime;
    return Math.round(porcentajeDeDiferenciaConRespectoAlMaximo);
  }

  cloG(object: Service): void{
    this.formModel = new FormularioDespacho();
    this.formModel.reqhdp = object.reqhdp;
    // Asignando valores del formulario que viene desde la tabla
    this.formModel.consecutivo = object.reqcsc;
    this.formModel.matricula = object.matricula;
    this.formModel.tpc = object.grutpc;
    this.formModel.radicado = object.grugru;
    this.formModel.nombreRadicado = object.grunom;
    this.formModel.nombre_titular = object.titnom;
    this.formModel.nombre_paciente = object.bennom;
    this.formModel.ID_Grupo = object.ID_Grupo;
    this.formModel.ID_Titular = object.ID_Titular;
    this.formModel.id_ben_ap = object.id_ben_ap;
    this.formModel.tel = object.bentel;
    this.formModel.cel = object.bencel;
    this.formModel.edad = object.edad;
    this.formModel.sexo = object.bensex;
    this.formModel.documento_paciente = object.bendoc;
    this.formModel.direccion = object.direccionCompleta || object.bendir;
    this.formModel.numeroReingresos = object.retiros;
    this.formModel.meses = object.PerTiempoBen;
    this.formModel.reqcda = object.reqcda;
    this.formModel.bening = object.bening.replace(/T+[^\n]+/g, "");
    this.formModel.t_Consultas = object.total_servicios;
    this.formModel.signos_sintomas = object.reqsig;
    this.formModel.eps = object.beneps;
    this.formModel.tel_llamada = object.reqtel;
    this.formModel.id_evaluacion = object.reqcdf;
    this.formModel.direccion_llamada = object.reqdir;
    this.formModel.nombre_llamada = object.reqper;
    this.formModel.reqtps = object.reqtps;
    this.formModel.reqfpg = object.reqfpg;
    this.formModel.cansrv = object.cansrv;
    this.formModel.reqnov = object.reqnov;
    this.formModel.bentxt = object.bentxt;
    this.formModel.infase = object.infase;
    this.formModel.reqtxo = object.reqtxo;
    this.formModel.reqcda2 = object.reqcda2;
    this.formModel.csctraslado = object.REGCSCTrasl;
    this.formModel.HConsCSC = object.HConsCSC;
    this.formModel.HCreaHC = object.HCreaHC;
    this.formModel.HMotAnte = object.HMotAnte;
    this.formModel.HExaFis = object.HExaFis;
    this.formModel.Htratamiento = object.Htratamiento;
    this.formModel.HFirma = object.HFirma;
    this.formModel.HCodiValo = object.HCodiValo;
    this.formModel.reqhll = object.reqhll;
    this.formModel.celNotificacion = object.celNotificacion;
    this.formModel.bencba = object.bencba;
    this.formModel.coordenadas = object.coordenadas;
    this.formModel.dirvalidada = object.direccionValidada;
    this.formModel.dircompleta = object.direccionCompleta;
    this.formModel.prioridadPorSintoma = object.prioridadPorSintoma;
    this.formModel.parqueadero = object.parqueadero;
    this.formModel.parqueadero_servicios = object.parqueadero_servicios;
    this.formModel.Ape = object.Ape;
    // En caso tal de que benrdo exista, se quitan todo lo que halla despues de la hora, para que no genere conflictos con los inputs
    if (object.benrdo){
      this.formModel.benrdo = null || object.benrdo.replace(/T+[^\n]+/g, "");
    }
    // En caso de que grutpc esté en alguno de las posibilidades que hay en el array lo toma cómo AP o sea, de areas protegidas
    if (this.apCod.indexOf(object.grutpc) > -1){
        this.formModel.ap = true;
        this.formModel.nombre_paciente = object.bennomAP || object.bennom ;
        this.formModel.eps = object.benepsAP || object.beneps;
        this.formModel.edad = object.edadAp || object.edad;
        this.formModel.sexo = object.bensexAP || object.bensex;
        this.formModel.documento_paciente = object.bendocAP || object.bendoc;
        this.serviciosService.totalConsultasOfAP(this.formModel.documento_paciente).subscribe((succ: any) => {
        this.formModel.t_Consultas = succ;
      });
    }

    this.serviciosService.smscount(this.formModel.consecutivo).subscribe((data)=>{
      this.formModel.sms = data;
      this.countsms = Object.keys(this.formModel.sms);
    })

    this.serviciosService.rellamadasOfAService(this.formModel.consecutivo).subscribe((data) => {
      this.formModel.rellamadas = data.length;
    })
  }

  // Activa el input de movil para editar
  setEdit(index): void{
    this.tableOpt[index].isMovEdit = true;
  }

  // Evento que se dispara con el doble click de cada uno de los campos de tiempo en la tabla de despacho
  update(prop, campo, csc, index, formProps?, value= ``): void{
    if (!this.tableOpt[index][prop]){
      this.serviciosService.updateTime(prop, campo, value, csc, formProps);
    }
  }

  switchTel(): void{
    // evento que se dispara despues de dar click en el boton de copy, para poner el telefono principal en telefono de donde se llama
    this.formModel.tel_llamada = this.formModel.tel || this.formModel.cel ;
    this.serviciosService.updateService(`reqtel`, `reqtel`, this.formModel.tel_llamada, this.formModel.consecutivo, ['tel_llamada']);
  }

  updateBentel(value): void{
    // Evento que se dispara cuando se sale del foco de un input. en caso tal de que sea ap emite el evento ap, sino el evento beneficiaro normal
    if (this.apCod.indexOf(this.formModel.tpc) > -1){
      this.serviciosService.updateBeneficiarioAP('bentel', 'bentel', value, this.formModel.documento_paciente, ['tel'], this.formModel.consecutivo);
    }else{
      this.serviciosService.updateBeneficiario('bentel', 'bentel', value, this.formModel.documento_paciente, ['tel'], this.formModel.consecutivo);
    }
  }

  /* esta funcion abre el modal CelularDespachoComponent y manda por parametros el celular, el concecutivo del servicio y
  id del usuario al que se le esta haciendo el servicio */
  sms():void{
    if (this.formModel.consecutivo != null && this.formModel.celNotificacion != null && this.formModel.celNotificacion.length === 10 ) {
      this.dialog.open(CelularDespachoComponent, {
        width: '70%',
        data: {
          numero: this.formModel.celNotificacion,
          csc: this.formModel.consecutivo,
          usuario: this.datosUsuario.id_usuario,
          grupo:this.formModel.ID_Grupo,
          titular:this.formModel.ID_Titular,
          beneficiario:this.formModel.id_ben_ap
        }
      });
    } else {
      this.snack.open('Ingrese un número celular', '', {
        duration: 2200,
        panelClass: 'warn-bg'
      })
    }
  }
  /* esta funcion abre el modal MovilDespachoComponent que muestra los datos de la movil que se le asigno a el servicio*/
  movil(object): boolean{
    this.datosMovil = object;
    this.dialog.open(MovilDespachoComponent, {
      data: {
        movil: this.datosMovil
      }
    });
    return false;
  }

  /* esta funcion se encarga de abrir el modal, de enviar el sms con la evaluacion del paciente */
  evaluacion():void{
    if (this.formModel.consecutivo != null && this.formModel.celNotificacion != null && this.formModel.celNotificacion.length === 10) {
      this.dialog.open(EvaluacionComponent, {
        width: '70%',
        data: {
          numero: this.formModel.celNotificacion,
          csc: this.formModel.consecutivo,
          usuario: this.datosUsuario.id_usuario,
          grupo: this.formModel.ID_Grupo,
          titular: this.formModel.ID_Titular,
          beneficiario: this.formModel.id_ben_ap
        }
      });
    } else {
      this.snack.open('Ingrese un número celular', '', {
        duration: 2200,
        panelClass: 'warn-bg'
      })
    }
  }

  prioridadporsintoma(){
    this.dialog.open(PrioridadPorSintomaComponent,{
      data:{
        csc: this.formModel.consecutivo,
        usuario: this.datosUsuario.id_usuario,
        prioridad: this.formModel.prioridadPorSintoma
      }
    })
  }

  infoCSC(){
    this.dialog.open(InfoConsecutivoComponent,{
      data:{
        csc: this.formModel.consecutivo
      }
    })
  }

  totalServicios(): void{
    if (this.formModel.consecutivo != null){
      this.dialog.open(TotalServiciosComponent, {
        data: {
          bendoc: this.formModel.documento_paciente
        }
      });
    }
  }

  bitacora(): void{
    if (this.formModel.consecutivo != null && this.formModel.documento_paciente != null) {
      this.dialog.open(BitacoraUsuarioComponent, {
        data: {
          bendoc: this.formModel.documento_paciente
        }
      });
    }
  }
  /* esta funcion abre el modal de pqrs */
  pqrs(): void{
    this.dialog.open(PqrsComponent, {
      width: '500px'
    });
  }
  /* esta funcion define la forma de pago que eligio el cliente  */
  formaPago(): void{
    if (this.formModel.consecutivo != null) {
      this.dialog.open(FormaPagoComponent, {
        data: {
          fpg: this.formModel.reqfpg,
          csc: this.formModel.consecutivo
        }
      });
    }
  }
  /* esta funcion se encarga de colocar el consecutivo por traslado */
  csctraslado(csc): void{
    if (this.formModel.consecutivo != null) {
      const consecutivo = csc;
      this.dialog.open(CscTrasladoComponent, {
        data: {
          consec: consecutivo
        }
      });
    }
  }
  /* esta funcion se encarga de poner el orden  del consecutivo a la hora de asignarlo */
  ordencsc(csc): void{
    if (this.formModel.consecutivo != null) {
      const consecutivo = csc;
      this.dialog.open(OrdenCscComponent, {
        data: {
          consec: consecutivo
        }
      });
    }
  }
  /* audio de aviso de consulta terminada */
  playAudio(): void {
    const audio = new Audio();
    audio.src = `../../../../assets/audio/SD_ALERT_1.mp3`;
    audio.load();
    audio.play();
  }
/* esta funcion muestra los sms que tiene el consecutivo seleccionado */
  infosms(){
    this.dialog.open(InfoSmsComponent,{
      data:{
        sms: this.formModel.sms
      }
    })
  }
  /* esta funcion abre los modales de los tabs de notas operador,consulta y antecedentes */
  notasDespacho(selectedwallet){
    if (selectedwallet == "Antecedentes") {
      this.dialog.open(NotasDespachoComponent,{
        data:{
          title:'Antecedentes',
          info: this.formModel.bentxt
        }
      })
    } else if (selectedwallet == "N.Consulta"){
      this.dialog.open(NotasDespachoComponent, {
        data: {
          title: 'N.Consulta',
          info: this.formModel.reqtxo
        }
      })
    } else if (selectedwallet == "N.Operador") {
      this.dialog.open(NotasDespachoComponent, {
        data: {
          title: 'N.Operador',
          info: this.formModel.infase
        }
      })
    }
  }

  updateServiceTel(value): void{
    this.serviciosService.updateService('reqtel', 'reqtel', value, this.formModel.consecutivo, ['tel_llamada']);
  }

  updateNombreLlamada(value): void{
    this.serviciosService.updateService('reqper', 'reqper', value, this.formModel.consecutivo, ['nombre_llamada']);
  }

  updateDireccionAlt(value): void{
    this.formModel.direccion_llamada = this.formModel.direccion;
    this.serviciosService.updateService('reqdir', 'reqdir', this.formModel.direccion_llamada, this.formModel.consecutivo, ['direccion_llamada']);
  }

  updateDireccionBeneficiario(value): void{
    this.serviciosService.updateBeneficiario('bendir', 'bendir', value, this.formModel.documento_paciente, ['direccion'], this.formModel.consecutivo);
  }
  cambioEPS(): void{
    // en caso tal de que sea ap emite el evento ap, sino el evento beneficiaro normal
    if (this.apCod.indexOf(this.formModel.tpc) > -1){
      this.serviciosService.updateBeneficiarioAP('beneps', 'beneps', this.formModel.eps, this.formModel.documento_paciente, ['eps'], this.formModel.consecutivo);
    }else{
      this.serviciosService.updateBeneficiario('beneps', 'beneps', this.formModel.eps, this.formModel.documento_paciente, ['eps'], this.formModel.consecutivo);
    }
  }
  changeSignos(){
    this.serviciosService.updateService('reqsig', 'reqsig', this.formModel.signos_sintomas, this.formModel.consecutivo, ['signos_sintomas']);
  }
  changeEvaluacion(){
    this.serviciosService.updateService('reqcdf', 'reqcdf', this.formModel.id_evaluacion, this.formModel.consecutivo, ['id_evaluacion']);
  }
  revalorar(){
    this.serviciosService.updateService('reqcda2', 'reqcda2', this.formModel.reqcda2, this.formModel.consecutivo, ['reqcda2']);
  }

  finalizarConsulta(i){
    this.tableOpt.splice(i, 1);
    this.formModel = new FormularioDespacho();
  }

  cambioTipoServicio(){
    this.serviciosService.updateService('reqtps', 'reqtps', this.formModel.reqtps, this.formModel.consecutivo, ['reqtps']);
  }
  cambioNovedad(){
    this.serviciosService.updateService('reqnov', 'reqnov', this.formModel.reqnov, this.formModel.consecutivo, ['reqnov']);
  }

  cambiarFPG(){
    this.serviciosService.updateService('reqfpg', 'reqfpg', this.formModel.reqfpg, this.formModel.consecutivo, ['reqfpg']);
  }

  cambiarMotivoCancel(){
    this.serviciosService.updateService('cansrv', 'cansrv', this.formModel.cansrv, this.formModel.consecutivo, ['cansrv']);
  }

  changeObsBen(campo: string){
    this.serviciosService.updateBeneficiario(campo, campo, this.formModel[campo], this.formModel.documento_paciente, [campo], this.formModel.consecutivo);
  }

  changeObs(campo: string){
    this.serviciosService.updateService(campo, campo, this.formModel[campo], this.formModel.consecutivo, [campo]);
  }

  updatTable(i, campo){
    this.tableOpt[i].isPrgEdit = false;
    this.tableOpt[i].isMovEdit = false;
    this.serviciosService.updateService(campo, campo, this.tableOpt[i][campo], this.formModel.consecutivo, []);
  }

  setEditPrg(i){
    this.tableOpt[i].isPrgEdit = true;
  }

  updateBenCel(){
    // en caso tal de que sea ap emite el evento ap, sino el evento beneficiaro normal
    if (this.apCod.indexOf(this.formModel.tpc) > -1){
      this.serviciosService.updateBeneficiarioAP('bencel', 'bencel', this.formModel.cel  , this.formModel.documento_paciente, ['cel'], this.formModel.consecutivo);
    } else{
      this.serviciosService.updateBeneficiario('bencel', 'bencel', this.formModel.cel  , this.formModel.documento_paciente, ['cel'], this.formModel.consecutivo);
    }
  }

  updateCelNoti(){
    this.serviciosService.updateService("celNotificacion", "celNotificacion", this.formModel["celNotificacion"], this.formModel.consecutivo, ["celNotificacion"]);
  }
  trKeyDown(event){}
  dirEmergenciaModal(){
    if (!this.formModel.consecutivo) { return; }
    let newDir:MatDialogRef<DireccionComponent> = this.dialog.open(DireccionComponent, {
        width: '60%',
        height: '79%',
        data: { actual_direccion: this.formModel.direccion,key:this.formModel.consecutivo,tipoDir:'servicio' },
        disableClose:true
    });

    newDir.afterClosed().subscribe(direccion=>{
        console.log(direccion);
        if(direccion){
            this._geo.saveDirService(direccion,this.formModel.consecutivo).subscribe(succ=>{
                swal.fire({
                    title:'Exito',
                    type:'success',
                    text:'Se guardó con exito la dirección',
                    showConfirmButton: false,
                    timer:1000
                })
            });
        }
    })
  }

  updateTriaje(){
    this.serviciosService.updateService('reqcda', 'reqcda', this.formModel.reqcda, this.formModel.consecutivo, ['reqcda']);
  }
}